export const BuildInfo = {timestamp:1771525396000}
